const PbxCsvUploadTypes = {
  PBX_LINES: 'PBX_LINES',
  PBX_LINE_DETAILS: 'PBX_LINE_DETAILS',
  PBX_DIRECTORY: 'PBX_DIRECTORY',
} as const;

export default PbxCsvUploadTypes;
